import { Fragment } from '@playbooks/core/src/interfaces'

import { BaseNode } from '../../actionCard'

export class RecommendationNode extends BaseNode {
  declare data: Fragment

  public get text(): string {
    return this.data.text || ''
  }

  public get name(): string {
    return this.data.name || ''
  }

  public get hideFromWebPlay(): boolean {
    return this.data.hideFromWebPlay || false
  }

  public get includeInWebPlayNotification(): boolean {
    return this.data.includeInWebPlayNotification || false
  }
}
